module.exports = __webpack_public_path__ + "Helvetica.123ad655fb9abc64b3e9.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-netsul/src/app/@theme/fontes/Helvetica/Helvetica.woff2
// module id = ../../../../../src/app/@theme/fontes/Helvetica/Helvetica.woff2
// module chunks = styles